import React, { Component } from 'react';
import content from '../../../constants/content';
import Table, { TableRow } from '../../templates/Table/Table';

import './styles.css';

type State = {
	content: {
        pricingPage: {
            info: {
                heading: string;
				rows: TableRow[]
            }
        }
    };
};

/**
 * Description
 *
 * @typedef {Object} Props
 * @prop {String} [example]
 *
 * @augments {Component<Props>}
 */
export default class PricingInfo extends Component<{}, State> {

	state = {
        content: content.en
    }

	render () {
		return (
			<div className='PricingInfo'>
				<Table
					{...this.state.content.pricingPage.info}
				/>
			</div>
		);
	}

}
